interface ContainerConstant {
  title: string;
  className: string;
  icon: string;
}
export const containerConstants: { [key: string]: ContainerConstant } = {
  tip: {
    title: "Tip",
    className: "learning-modules-container__mainContent__fieldSet--tip",
    icon: "wb_sunny",
  },
  example: {
    title: "Example",
    className: "learning-modules-container__mainContent__fieldSet--example",
    icon: "attachment",
  },
  takeHome: {
    title: "Take Home Message",
    className: "learning-modules-container__mainContent__fieldSet--takeHome",
    icon: "chat_bubble",
  },
};
